module.exports = __webpack_public_path__ + "img/shipo-icon-weather-foggy.4a7707a2.svg";